export class OtherContentData {
  private id: number
  private name: string
  private content: string

  constructor(id: number, name: string, content: string) {
    {
      this.id = id
      this.name = name
      this.content = content
    }
  }
}

export class OtherContent {
  public success: boolean
  public message: string
  public data?: OtherContentData[]

  constructor(success: boolean, message: string, data?: OtherContentData[]) {
    this.success = success
    this.message = message
    this.data = data
  }
}
